import { AutomateTask, success } from "@iflyrpa/share";
import { errorResponse } from "../../types";
import { TimeFormatter } from "../../utils";
import { Http } from "../../utils/http";
import { type SearchAccountInfoParams } from ".";
import { bjhConfigData, SearchAccountInfoResponse } from "./types";

export async function getBaijiahaoData(
    _task: AutomateTask,
    params: SearchAccountInfoParams,
): Promise<SearchAccountInfoResponse> {
    const { token } = params;
    if (!token) return errorResponse("缺少token", 414);

    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            token: String(token),
            Referer: "https://baijiahao.baidu.com/builder/rc/home",
        },
    });

    const yesterday = TimeFormatter.format(new Date().setDate(new Date().getDate() - 1), "yyyyMMdd");
    const [fansData, readData, incomeData, yesterdayData] = await Promise.all([
        http.api<{ errno: number; data: { coreData: { fansCount: number } } }>({
            method: "get",
            url: "https://baijiahao.baidu.com/pcui/home/index",
        }),
        http.api<{ errno: number; data: { total: { view_count: number } } }>({
            method: "get",
            url: "https://baijiahao.baidu.com/author/eco/statistic/getauthorhistory",
        }),
        http.api<{ errno: number; data: { all_income: { total_income: number; yesterday_income: number } } }>({
            method: "get",
            url: "https://baijiahao.baidu.com/author/eco/income4/homepageincome",
        }),
        http.api<{
            errno: number;
            data: {
                data: {
                    recommend_count: number;
                    view_count: number;
                    likes_count: number;
                    comment_count: number;
                    fans_increase: number;
                };
            };
        }>({
            method: "get",
            url: "https://baijiahao.baidu.com/author/eco/statistics/appStatistic",
            params: {
                type: "all",
                is_yesterday: false,
                start_day: yesterday,
                end_day: yesterday,
                stat: 0,
            },
        }),
    ]);
    if (fansData.errno !== 0 || readData.errno !== 0 || incomeData.errno !== 0 || yesterdayData.errno !== 0) {
        return errorResponse("百家号数据获取失败，请检查账号状态", 414);
    }

    const bjhData: bjhConfigData = {
        fansNum: fansData.data.coreData.fansCount,
        fansNumYesterday: yesterdayData.data.data.fans_increase === -1 ? null : yesterdayData.data.data.fans_increase,
        readNum: readData.data.total.view_count,
        incomeNum: incomeData.data.all_income.total_income,
        incomeNumYesterday:
            incomeData.data.all_income.yesterday_income === -1 ? null : incomeData.data.all_income.yesterday_income,
        recommendNumYesterday:
            yesterdayData.data.data.recommend_count === -1 ? null : yesterdayData.data.data.recommend_count,
        readNumYesterday: yesterdayData.data.data.view_count === -1 ? null : yesterdayData.data.data.view_count,
        likeNumYesterday: yesterdayData.data.data.likes_count === -1 ? null : yesterdayData.data.data.likes_count,
        commentNumYesterday:
            yesterdayData.data.data.comment_count === -1 ? null : yesterdayData.data.data.comment_count,
    };

    return success(bjhData, "百家号平台数据获取成功！");
}
